export default "__VITE_ASSET__Dk2JA8RU__"